import React from 'react';
import Icon from '@mui/material/Icon';
import styled from 'styled-components';

export default function SvgFile({ src, style, className, ...other }) {
  return (
    <StyledIcon {...other}>
      <img {...{ src, style, className }}/>
    </StyledIcon>
  );
}

const StyledIcon = styled(Icon)`
  img {
    height: 100%;
    vertical-align: top;
  }
`;
